// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import router from "./router";
import VueAxios from "vue-axios";
import axios from "axios";
import store from './store'

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

import compLoader from "./components/Loader";
Vue.component("app-loader", compLoader);

Vue.use(Vuex);
Vue.use(VueAxios, axios);

Vue.use(VueMaterial);

import VueLazyload from "vue-lazyload";
//Vue.use(VueLazyload);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: process.env.VUE_APP_ROOT_IMG + "no-image.png",
  loading: process.env.VUE_APP_ROOT_IMG + "no-image.png",
  attempt: 1
});

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)

import JwPagination from "jw-vue-pagination";
Vue.component("jw-pagination", JwPagination);

import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize)
/**
 * Vue backtotop
 * https://github.com/caiofsouza/vue-backtotop
 */
import BackToTop from "vue-backtotop";
Vue.use(BackToTop);

import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

Vue.config.productionTip = true
Vue.prototype.$comparison = true // porównywarka
Vue.prototype.$moreOptions = false // opcje zaawansowane

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

/**
 * Vue-i18n
 */
import VueI18n from "vue-i18n";
import { messages } from "./translations/messages";
import { lang } from "./translations/lang";

Vue.use(VueI18n);
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: "pl", // when no EN translate
  messages // set locale messages
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js